import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

export const SORT_ICON_SIZE_LEFT = 99;
export const SORT_ICON_SIZE_RIGHT = 109;

export const Wrapper = styled.div`
    && {
        display: inline-flex;
        background: #ffffff1a;
        border-radius: 20px;
        position: relative;
        display: flex;
        align-items: center;
    }
`;

export const DirectionIndicator = styled(motion.div)`
    && {
        position: absolute;
        width: ${SORT_ICON_SIZE_LEFT}px;
        height: 100%;
        background: ${({ theme }) => theme.colors.purple};
        border-radius: 20px;
    }
`;

export const DirectionButton = styled(motion(ButtonIcon))`
    &&& {
        width: 102.5px;
    }
`;
